import { ReactElement, ReactNode } from 'react'

export default <P = any>(el: ReactNode): el is ReactElement<P> =>
  typeof el !== 'string' && typeof el !== 'number'
